<template>
  <v-layout row>
    <v-flex
      xs12
      md6
      offset-md3>
      <v-card>
        <v-toolbar
          color="primary"
          flat
          dark>
          <v-toolbar-side-icon><v-icon>fas fa-lock</v-icon></v-toolbar-side-icon>

          <v-toolbar-title>Sicherheit und Login</v-toolbar-title>
        </v-toolbar>
       
        <v-list
          
          two-line
          subheader>
          <v-list-tile v-if="error">
            <app-alert 
              :text="error.message" 
              @dismissed="onDismissed"></app-alert>
          </v-list-tile>

          <v-list-tile v-if="success">
            <app-success 
              :text="success" 
              @dismissed="onDismissedSuccess"></app-success>
          </v-list-tile>


          <v-subheader>
            E-Mail ändern
          </v-subheader>
          <form @submit.prevent="changeEmailButton">
            <v-list-tile>
              <v-text-field
                v-model="emailOld"
                prepend-inner-icon="fas fa-envelope"
                placeholder="Alte Email Adresse bestätigen"
                :error-messages="emailOldErrors"
                solo
                type="email"
                @change="$v.emailOld.$touch()"
                @blur="$v.emailOld.$touch()">
              </v-text-field>
            </v-list-tile>
          
            <v-list-tile>
              <v-text-field
                v-model="emailNew"
                prepend-inner-icon="far fa-envelope-open"
                placeholder="Neue Email Adresse"
                :error-messages="emailNewErrors"
                solo
                type="email"
                @change="$v.emailNew.$touch()"
                @blur="$v.emailNew.$touch()">
              </v-text-field>
            </v-list-tile>

            <v-list-tile>
              <v-text-field
                v-model="passwordEmail"
                prepend-inner-icon="fas fa-unlock"
                :type="showPwEmail ? 'text' : 'password'"
                :append-icon="showPwEmail ? 'fas fa-eye' : 'fas fa-eye-slash'"
                placeholder="Password"
                :error-messages="passwordEmailErrors"
                solo
                @click:append="showPwEmail = !showPwEmail"
                @change="$v.passwordEmail.$touch()"
                @blur="$v.passwordEmail.$touch()">
              </v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-spacer></v-spacer>
              <v-btn
                round
                type="submit"
                :loading="this.$store.getters.loading"
                color="primary">
                Email ändern
              </v-btn>
            </v-list-tile>
          </form>

          <v-divider></v-divider>


          <v-subheader>
            Passwort ändern
          </v-subheader>

          <form @submit.prevent="changePasswordButton">
            <v-list-tile>
              <v-text-field
                v-model="passwordOld"
                :type="showPwOld ? 'text' : 'password'"
                :append-icon="showPwOld ? 'fas fa-eye' : 'fas fa-eye-slash'"
                prepend-inner-icon="fas fa-unlock"
                placeholder="Altes Passwort"
                :error-messages="passwordOldErrors"
              
                solo
                @click:append="showPwOld = !showPwOld"
                @change="$v.passwordOld.$touch()"
                @blur="$v.passwordOld.$touch()">
              </v-text-field>
            </v-list-tile>
                  
            <v-list-tile>
              <v-text-field
                v-model="passwordNew"
                :type="showPwNew ? 'text' : 'password'"
                :append-icon="showPwNew ? 'fas fa-eye' : 'fas fa-eye-slash'"
                prepend-inner-icon="fas fa-lock"
                placeholder="Neues Passwort"
                :error-messages="passwordNewErrors"
              
                solo
                @click:append="showPwNew = !showPwNew"
                @change="$v.passwordNew.$touch()"
                @blur="$v.passwordNew.$touch()">
              </v-text-field>
            </v-list-tile>
          
            <v-list-tile>
              <v-text-field
                v-model="passwordConfirm"
                :type="showPwNewConf ? 'text' : 'password'"
                :append-icon="showPwNewConf ? 'fas fa-eye' : 'fas fa-eye-slash'"
                prepend-inner-icon="fas fa-lock"

                placeholder="Password bestätigen"
                :error-messages="passwordConfirmErrors"
              
                solo
                @click:append="showPwNewConf = !showPwNewConf"
                @change="$v.passwordConfirm.$touch()"
                @blur="$v.passwordConfirm.$touch()">
              </v-text-field>
            </v-list-tile>
            <v-list-tile>
              <v-spacer></v-spacer>
              <v-btn
                round
                type="submit"
                color="primary"
                :loading="this.$store.getters.loading">
                Passwort ändern
              </v-btn>
            </v-list-tile>
          </form>
        </v-list>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      showPwOld: false,
      showPwNew: false,
      showPwNewConf: false,
      passwordOld: '',
      passwordNew: '',
      passwordConfirm: '',

      showPwEmail: false, 
      emailOld: '',
      emailNew: '',
      passwordEmail: ''
    }
  },
  validations: {
    passwordOld: {
      required,
      minLength: minLength(6),
    },
    passwordNew: {
      required,
      minLength: minLength(6),
    },
    passwordConfirm: {
      required,
      minLength: minLength(6),
      sameAsPassword: sameAs('passwordNew')
    },

    emailOld: {
      required,
      email
    },
    emailNew: {
      required,
      email
    },
    passwordEmail: {
      required,
      minLength: minLength(6),
    },
  },
  computed: {
    ...mapGetters({
      error: 'error',
      success: 'success',
    }),
    emailOldErrors() {
      const errors = []
      if (!this.$v.emailOld.$dirty) return errors
      !this.$v.emailOld.required && errors.push('Email is required.')
      !this.$v.emailOld.email && errors.push('Invalid Email.')
      return errors
    },
    emailNewErrors() {
      const errors = []
      if (!this.$v.emailNew.$dirty) return errors
      // Textbaustein
      !this.$v.emailNew.required && errors.push('Email is required.')
      !this.$v.emailNew.email && errors.push('Invalid Email.')
      return errors
    },
    passwordEmailErrors() {
      const errors = []
      if (!this.$v.passwordEmail.$dirty) return errors
      !this.$v.passwordEmail.minLength && errors.push('Password must have at least ' + this.$v.passwordEmail.$params.minLength.min + ' letters.')
      !this.$v.passwordEmail.required && errors.push('Password is required.')
      return errors
    },
    passwordOldErrors() {
      const errors = []
      if (!this.$v.passwordOld.$dirty) return errors
      !this.$v.passwordOld.minLength && errors.push('Password must have at least ' + this.$v.passwordOld.$params.minLength.min + ' letters.')
      !this.$v.passwordOld.required && errors.push('Password is required.')
      return errors
    },
    passwordNewErrors() {
      const errors = []
      if (!this.$v.passwordNew.$dirty) return errors
      !this.$v.passwordNew.minLength && errors.push('Password must have at least ' + this.$v.passwordNew.$params.minLength.min + ' letters.')
      !this.$v.passwordNew.required && errors.push('Password is required.')
      return errors
    },
    passwordConfirmErrors() {
      const errors = []
      if (!this.$v.passwordConfirm.$dirty) return errors
      !this.$v.passwordConfirm.required && errors.push('Please confirm the password.')
      !this.$v.passwordConfirm.minLength && errors.push('Password must have at least ' + this.$v.passwordConfirm.$params.minLength.min + ' letters.')
      !this.$v.passwordConfirm.sameAsPassword && errors.push('Passwords do not match!')
      return errors
    },

    passwordChangeIsValid() {
      return (
        !this.$v.passwordOld.$invalid &&
        !this.$v.passwordNew.$invalid &&
        !this.$v.passwordConfirm.$invalid
      )
    },
    eamilChangeIsValid() {
      return (
        !this.$v.emailOld.$invalid &&
        !this.$v.emailNew.$invalid &&
        !this.$v.passwordEmail.$invalid
      )
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    onDismissedSuccess () {
      this.$store.dispatch('clearSuccess')
    },
    changeEmailButton() {
      if (!this.eamilChangeIsValid) {
        this.$v.emailOld.$touch()
        this.$v.emailNew.$touch()
        this.$v.passwordEmail.$touch()
        console.log('dontChange')
      } else {
        const changeEmail = {
          emailOld: this.emailOld,
          emailNew: this.emailNew,
          passwordEmail: this.passwordEmail
        }
        this.$store.dispatch('changeEmail', changeEmail)

        this.emailOld = ''
        this.emailNew = ''
        this.passwordEmail = ''

        this.$v.emailOld.$reset()
        this.$v.emailNew.$reset()
        this.$v.passwordEmail.$reset()
      }

    },
    changePasswordButton() {
      if (!this.passwordChangeIsValid) 
      {
        this.$v.passwordOld.$touch()
        this.$v.passwordNew.$touch()
        this.$v.passwordConfirm.$touch()
        console.log('dontChange')

      } else {
        console.log('change')
        const changePW = {
          passwordOld: this.passwordOld,
          passwordNew: this.passwordNew,
          passwordConfirm: this.passwordConfirm
        }
        this.$store.dispatch('changePassword', changePW)

        this.passwordOld = ''
        this.passwordNew = ''
        this.passwordConfirm = ''

        this.$v.passwordOld.$reset()
        this.$v.passwordNew.$reset()
        this.$v.passwordConfirm.$reset()
        

      }
    }
  }
}
</script>


